import { Box, Dialog, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from "@mui/material";
import { Report } from "model/Report";
import { User } from "model/User";
import * as reportRepository from "repository/ReportRepository"

type Props = {
  user: User
  opponent: User
  media: {isPc: boolean}
  report: Report
}
export default function ReportDialog(props: Props) {

  async function handleAgree() {
    const report = Object.assign({}, props.report)
    report.agreed = true
    report.report_time = new Date().getTime()
    reportRepository.update(report)
  }

  async function handleDisagree() {
    const report = Object.assign({}, props.report)
    report.agreed = false
    report.report_time = new Date().getTime()
    reportRepository.update(report)
  }

  return (
    <Dialog open={props.report.uuid === props.opponent.uuid && props.report.agreed === null}>
      <Box sx={{
        height: props.media.isPc ? '480px' : '420px',
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        bgcolor: 'background.default',
        p: props.media.isPc ? 7 : 3,
      }}>
        <Grid container>
          <Grid item xs={12} textAlign='center'>
            <Typography variant={props.media.isPc ? 'h5' : 'body1'}>
              {props.opponent.name} さんの勝利です。
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign='center' sx={{mt: 5, mb: 1}}>
            <Typography>
              あなたの戦績
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{pr: props.media.isPc ? 10 : 3, pl: props.media.isPc ? 10 : 3}}>
            <TableContainer>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell>試合数</TableCell>
                    <TableCell>先後</TableCell>
                    <TableCell>勝敗</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    props.report.duels?.map(duel => (
                      <TableRow key={duel.game_number}>
                        <TableCell>{duel.game_number}</TableCell>
                        <TableCell>{!duel.is_first ? '先攻' : '後攻'}</TableCell>
                        <TableCell>{!duel.is_win ? '勝ち' : '負け'}</TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <div style={{flex: 1}} />
        <Grid container>
          <Grid item xs={12} textAlign='center' sx={{mb: 1}}>
            <Typography>
              承認しますか？
            </Typography>
          </Grid>
          <Grid item xs={2} textAlign='center' />
          <Grid item xs={4} textAlign='center'>
            <Button variant='outlined' color='warning' onClick={handleDisagree}>しない</Button>
          </Grid>
          <Grid item xs={4} textAlign='center'>
            <Button variant='outlined' onClick={handleAgree}>する</Button>
          </Grid>
          <Grid item xs={2} textAlign='center' />
        </Grid>
      </Box>
    </Dialog>
  )
}